// extracted by mini-css-extract-plugin
export var table = "_vd-0";